/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkflowAccess } from './workflowAccess';


export interface WorkflowResultResponse { 
    /**
     * the total number of results
     */
    count: number;
    result: Array<WorkflowAccess>;
}

